// Front-end entry point (built by Vite; loaded via craft.vite.script in templates/_page.twig).
// Montserrat is self-hosted (one variable woff2, font-display: swap) so it ships in our CSS instead of a
// render-blocking Google Fonts request on another origin.
import '@fontsource-variable/montserrat';
import '../scss/main.scss';

import LazyLoad from 'vanilla-lazyload';

window.wghi = window.wghi || {};

// Patient tiles' before/after backgrounds (.lazy[data-bg]); GalleryFilter calls update() after filtering.
window.lazyLoadInstance = new LazyLoad({ elements_selector: '.lazy' });

// Attribution first: it records this visit's UTMs before anything (FormEmbed) reads them.
import './Attribution.js';
import './FormEmbed.js';
import './FormStart.js';
import './BookingForm.js';

// Site modules attach themselves to window.wghi (legacy IIFE style), in the old Gulp concat order.
import './Accordion.js';
import './FilterController.js';
import './FilterBar.js';
import './GalleryFilter.js';
import './LinkMenu.js';
import './Intersection.js';
import './Journey.js';
import './PatientLightbox.js';
import './TeamMemberMiniCarousel.js';
import './Tooltip.js';
import './VideoPlayer.js';
import './VipMiniCarousel.js';
import './helpers.js';
import './StatCounter.js';
import './SiteNav.js';
import './MobileActionBar.js';

// After FormEmbed (window.wghi.formEmbed): registers the WebMCP tools for AI agents.
import './WebMcp.js';
